import { ArrowDownSmallIcon } from '@blocksuite/icons/lit';

export const EditorChevronDown = ArrowDownSmallIcon({
  style: 'display: flex;',
  width: '16px',
  height: '16px',
});
